import { useNotificationsQuery } from "@src/__generated__/urql-graphql";
import { useEffect } from "react";
import type { NotificationsStore } from "../store";

/**
 * Poll notifications for Popup
 **/
export const usePollNotifications = (
  store: NotificationsStore,
  options: {
    /** Number of notifications */
    first: number;
  },
) => {
  const [{ data, fetching }, refetch] = useNotificationsQuery({
    pause: true,
    variables: {
      first: options.first,
      groups: store.notificationGroups,
      read: store.showReadFilter,
    },
  });

  useEffect(() => {
    store.setLoading(fetching);
  }, [fetching]);

  useEffect(() => {
    if (!data) return;

    store.setNotifications(data);
  }, [data]);

  useEffect(() => {
    store.setNotifications({
      notifications: {
        data: [],
        paginatorInfo: {
          count: 0,
          total: 0,
          perPage: 7,
          lastPage: 1,
          currentPage: 1,
          hasMorePages: false,
        },
      },
    });
    refetch();
  }, [
    store.notificationGroups.length,
    store.showReadNotifications,
    store.popoverDisclosure.isOpen,
  ]);

  store.refetch = () => {
    refetch();
  };
};
